import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EcplDocumentTreeComponent } from './ecpl-document-tree.component';
import { TreeRootComponent } from './tree-shim/tree-root.component';
import { TreeNodeContentComponent } from './tree-shim/tree-node-content.component';
import { TreeNodeExpanderComponent } from './tree-shim/tree-node-expander.component';
import { TreeModule as PrimeTreeModule } from 'primeng/tree';
import { EcplPdfViewerModule } from '../ecpl-pdf-viewer/ecpl-pdf-viewer.module';
import { EcplOnlyofficeViewerModule } from '../ecpl-onlyoffice-viewer/ecpl-onlyoffice-viewer.module';
import { EcplImageViewerModule } from '../ecpl-image-viewer/ecpl-image-viewer.module';
import { EcplArticleViewerModule } from '../ecpl-article-viewer/ecpl-article-viewer.module';
import { EcplChecklistViewerModule } from '../ecpl-checklist-viewer/ecpl-checklist-viewer.module';
import { EcplLarViewerModule } from '../ecpl-lar-viewer/ecpl-lar-viewer.module';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { TreeDragDirective } from './tree-shim/tree-drag.directive';
import { TreeAllowDropDirective } from './tree-shim/tree-allow-drop.directive';
import { TreeDragEnabledDirective } from './tree-shim/tree-drag-enabled.directive';
import { ActiveFileCount, ActiveFolderCount } from '../../_helpers/pipes';
import { DefaultFolderTranslate } from '../../_helpers/pipes';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { HelperV2Service } from '../../_services/helper-v2.service';
import { DragDropService } from './drag-drop.service';
import { WidgetsModule } from '../../kuba/shared/widgets.module';
import { TreeDragDropService } from 'primeng/api';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    PrimeTreeModule,
    ModalModule,
    EcplPdfViewerModule,
    EcplOnlyofficeViewerModule,
    EcplImageViewerModule,
    EcplArticleViewerModule,
    EcplChecklistViewerModule,
    EcplLarViewerModule,
    ContextMenuModule,
    DialogModule,
    ScrollingModule,
    TranslatePipe, TranslateDirective,
    WidgetsModule
  ],
  declarations: [
    ActiveFileCount,
    EcplDocumentTreeComponent,
    DefaultFolderTranslate,
    ActiveFolderCount,
    TreeRootComponent,
    TreeNodeContentComponent,
    TreeNodeExpanderComponent,
    TreeDragDirective,
    TreeAllowDropDirective,
    TreeDragEnabledDirective
  ],
  providers: [HelperV2Service, DragDropService, TreeDragDropService],
  exports: [
    EcplDocumentTreeComponent,
    TreeRootComponent,
    TreeNodeContentComponent,
    TreeNodeExpanderComponent,
    WidgetsModule
  ]
})
export class EcplDocumentTreeModule {}
